<template>

    <m-edit1/>

    <m-factor-9 v-bind='{...{"defaultGate":"all"},...{}}' :style='""' class="" ></m-factor-9>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor9 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor9';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor9 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
